import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoreVert = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.2045 5.20451C11.6438 4.76516 12.3562 4.76516 12.7955 5.20451C13.2348 5.64385 13.2348 6.35616 12.7955 6.7955C12.3562 7.23484 11.6438 7.23484 11.2045 6.7955C10.7652 6.35616 10.7652 5.64385 11.2045 5.20451ZM11.2045 11.2045C11.6438 10.7652 12.3562 10.7652 12.7955 11.2045C13.2348 11.6438 13.2348 12.3562 12.7955 12.7955C12.3562 13.2348 11.6438 13.2348 11.2045 12.7955C10.7652 12.3562 10.7652 11.6438 11.2045 11.2045ZM11.2045 17.2045C11.6438 16.7652 12.3562 16.7652 12.7955 17.2045C13.2348 17.6438 13.2348 18.3562 12.7955 18.7955C12.3562 19.2348 11.6438 19.2348 11.2045 18.7955C10.7652 18.3562 10.7652 17.6438 11.2045 17.2045Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgMoreVert);
export default ForwardRef;
